import React from 'react';
import { Upload, message } from 'antd';
import { Storage } from 'aws-amplify';
import compose from 'lodash/flowRight';
import { graphql } from 'react-apollo';
import PropTypes from 'prop-types';
import CREATE_MEDIA_ADMIN from '../../../../core/GraphQl/Mutations/CREATE_MEDIA_ADMIN';
import { campaignTypeMap, IAB_DISPLAY_DIMENSIONS } from '../../../../core/utils/constants/constants';
import { validateAndResizeCreative } from '../../../shared/upload/validateAndResizeCreative';

const BannerUploader = ({ adUnit, button, index, bulkCreateCreatives, type: campaignType }) => {
  const medias = [];
  const invalidMedias = [];
  const uploaderProps = {
    name: 'file',
    action: null,
    multiple: true,
    beforeUpload: async (file, fileList) => {
      try {
        message.destroy();
        message.loading('Processing creatives...', 0);

        const { name, size, type } = file;

        if (campaignType !== campaignTypeMap.VIDEO && type === 'video/mp4') {
          message.destroy();
          message.error('File must be an image');
          return;
        }

        if (campaignType === campaignTypeMap.VIDEO && type !== 'video/mp4') {
          message.destroy();
          message.error('File must be mp4');
          return;
        }

        if (size > 2000000) {
          message.destroy();
          message.error("File can't exceed 2MB");
          return;
        }

        // Validate dimensions and auto-resize retina assets before upload
        let processedFile = file;
        let imageWidth = 0;
        let imageHeight = 0;
        try {
          const result = await validateAndResizeCreative(file, IAB_DISPLAY_DIMENSIONS);
          processedFile = result.file;
          imageWidth = result.width;
          imageHeight = result.height;
        } catch (err) {
          message.destroy();
          message.error(err.message);
          invalidMedias.push(file.uid);
          return;
        }

        const fname = `${new Date().getTime()}-${processedFile.name}`;
        const response = await Storage.put(fname, processedFile, {
          contentType: 'image/*',
        });
        const { key } = response;
        const url = await Storage.get(response.key, { expires: 600000 });

        let fileType = key.split('.')[1].toUpperCase();

        medias.push({
          type: 'STILL',
          key,
          url,
          width: imageWidth,
          height: imageHeight,
          name,
          size,
          fileType,
        });

        const validFiles = fileList.filter((fList) => !invalidMedias.includes(fList.uid));

        if (medias.length === validFiles.length) {
          bulkCreateCreatives({ medias, invalidMedias, adUnitIndex: index });
        }
      } catch (error) {
        message.error('Error uploading file');
      }
    },
    showUploadList: false,
    accept: '.png, .jpeg, .jpg, .gif, .avif',
    customRequest: async () => {
      setTimeout(() => {
        return true;
      }, 0);
    },
  };
  return <Upload {...uploaderProps}>{button}</Upload>;
};

BannerUploader.propTypes = {
  image: PropTypes.object,
  onChangeArrayOfObj: PropTypes.func,
  adUnit: PropTypes.object,
  button: PropTypes.node,
  index: PropTypes.number,
  onChange: PropTypes.func,
  handleUpdateCampaignOrder: PropTypes.func,
};

export default compose(graphql(CREATE_MEDIA_ADMIN, { name: 'createMediaMutation' }))(
  BannerUploader
);
